export default __webpack_public_path__ + "static/media/ProductsList_PC_img2_En.7c824b20.webp";